import { createContext } from 'react';

// we used to destroy fields by doing a form reset, but this has side effects like removing the dirty fields state
// so instead use this context to tell the field to set its value to null instead of resetting the form

const WorkAroundLegacyFieldDestroy = createContext(false);

export default WorkAroundLegacyFieldDestroy;
